import { CircularProgress } from '@mui/material';
import { Stack } from '@mui/system';

export const MapLoader = () => (
  <Stack alignItems='center'>
    <CircularProgress color='inherit' />
  </Stack>
);
